module.exports = __webpack_public_path__ + "img/terroir-disc-2.fabd737e.jpg";